import * as immutable from 'object-path-immutable';

export default {
  state: {
    canMail: 1,
    canImportLeads: 0,
    canAccessInternalSmtp: 0,
  },

  getters: {
    getCanMail: state => state.canMail,
    getCanImportLeads: state => state.canImportLeads,
    getCanAccessInternalSmtp: state => state.canAccessInternalSmtp,
  },
  
  mutations: {
    SET_CAN_MAIL(state, payload) {
      state.canMail = immutable.set(state.canMail, '', payload);
    },
    SET_CAN_IMPORT_LEADS(state, payload) {
      state.canImportLeads = immutable.set(state.canImportLeads, '', payload);
    },
    SET_CAN_ACCESS_INTERNAL_SMTP(state, payload) {
      state.canAccessInternalSmtp = immutable.set(state.canAccessInternalSmtp, '', payload);
    },
  },
  namespaced: true
};
